import React from 'react';
import dateHelper from '../../util/dateHelper';
import { LinkV2 } from '../LinkV2';
import ZolaLogo from '../ZolaLogo';

const StoreLinks = (): JSX.Element => {
  const year = dateHelper.getFullYear();
  return (
    <div className="common-footer__social-and-terms store-links">
      <ZolaLogo id="zola-store-logo" className="zola-store-logo zola-store-logo-rebrand" />
      <div className="store-footer-links__cols-container">
        <ul className="store-footer-links left-col">
          <li>
            <LinkV2 href="/wedding-registry/couple-reviews" noUnderline subtle>
              Zola Reviews
            </LinkV2>
          </li>
          <li>
            <LinkV2
              href="https://help.zola.com/hc"
              target="_blank"
              rel="noopener noreferrer"
              noUnderline
              subtle
            >
              FAQs
            </LinkV2>
          </li>
          <li>
            <LinkV2 href="/order-status" noUnderline subtle>
              Track Order
            </LinkV2>
          </li>
        </ul>
        <ul className="store-footer-links right-col">
          <li>
            <LinkV2 href="/order-status" noUnderline subtle>
              Start A Return
            </LinkV2>
          </li>
          <li>
            <LinkV2 href="/returns" noUnderline subtle>
              Return Policy
            </LinkV2>
          </li>
          <li>
            <LinkV2 href="/contact-us" noUnderline subtle>
              Contact Us
            </LinkV2>
          </li>
        </ul>
      </div>
      <ul className="store-footer-links">
        <li>
          <LinkV2 href="/wedding-registry/couple-reviews" noUnderline subtle>
            Zola Reviews
          </LinkV2>
        </li>
        <li>
          <LinkV2
            href="https://help.zola.com/hc"
            target="_blank"
            rel="noopener noreferrer"
            noUnderline
            subtle
          >
            FAQs
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/order-status" noUnderline subtle>
            Track Order
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/order-status" noUnderline subtle>
            Start A Return
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/returns" noUnderline subtle>
            Return Policy
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/contact-us" noUnderline subtle>
            Contact Us
          </LinkV2>
        </li>
      </ul>
      <div className="copyright">
        &copy; <span className="date">{year}</span> Zola, Inc. All rights reserved.
      </div>
      <ul className="terms-links store-footer">
        <li>
          <LinkV2 href="/privacy" target="_blank" rel="noopener noreferrer" noUnderline subtle>
            Privacy Policy
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/terms" target="_blank" rel="noopener noreferrer" noUnderline subtle>
            Terms of Use
          </LinkV2>
        </li>
        <li>
          <LinkV2 href="/webaccessibility" target="_self" noUnderline subtle>
            Web Accessibility
          </LinkV2>
        </li>
        <li>
          <LinkV2
            href="/privacy-center"
            target="_blank"
            rel="noopener noreferrer"
            noUnderline
            subtle
          >
            Do Not Sell / Share My Personal Information
          </LinkV2>
        </li>
      </ul>
    </div>
  );
};

export default StoreLinks;
